import { TransactionStatus, TransactionType } from './transaction.model';

export interface TransactionFilters {
  status?: TransactionStatus | '';
  type?: TransactionType | '';
  provider?: string;
  date_from?: string;
  date_to?: string;
  min_amount?: string;
  max_amount?: string;
  funding?: 'ejor' | 'gift' | 'direct' | '';
  source?: 'manual' | 'scheduled' | 'pay_now' | '';
}

export const TRANSACTION_STATUS_OPTIONS: TransactionStatus[] = [
  'INITIATED',
  'PROCESSING',
  'SUCCESSFUL',
  'FAILED',
  'UNKNOWN',
  'REVERSAL_PENDING',
  'REVERSED',
];

export const TRANSACTION_TYPE_OPTIONS: TransactionType[] = [
  'AIRTIME',
  'MOBILE_DATA',
  'CABLE_TV',
  'ELECTRICITY',
  'GIFT',
];

export const TRANSACTION_SOURCE_OPTIONS: { value: string; label: string }[] = [
  { value: 'manual', label: 'Manual' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'pay_now', label: 'Pay now' },
];

export const TRANSACTION_FUNDING_OPTIONS: { value: string; label: string }[] = [
  { value: 'direct', label: 'Paid directly' },
  { value: 'ejor', label: 'Paid through Ejor' },
  { value: 'gift', label: 'Dash gifts' },
];
